import { useTranslation } from 'react-i18next';
import ChangePasswordForm from '../change-password-form/change-password-form';
import PersonalInformationForm from '../personal-information-form/personal-information-form';
import {
  LoadingSpinner,
  useAuthUser,
  useCompanyFeature,
} from '@employ-engage/common-components';
import { CompanyFeaturesEnum } from '@employ-engage/data';
import UserPhoneNumbers from './user-phone-numbers';

/* eslint-disable-next-line */
export interface AccountSettingsProps {}

export function AccountSettings(props: AccountSettingsProps) {
  const { user } = useAuthUser();
  const { t } = useTranslation(['common']);
  const { feature: multiplePhoneNumbers } = useCompanyFeature(
    CompanyFeaturesEnum.MULTIPLE_PHONE_NUMBERS
  );

  if (!user) {
    return <LoadingSpinner spinnerId='account-settings-loading' />;
  }

  return (
    <div className="divide-y divide-white/5 flex flex-col gap-3.5 justify-start mt-3.5">
      <div>
        <h2 className="text-base font-semibold leading-7 text-light-primaryText dark:text-dark-primaryText">
          {t('Personal Information')}
        </h2>
        <p className="mt-1 text-sm leading-6 text-light-primaryText dark:text-dark-primaryText">
          {t('Use a permanent address where you can receive mail.')}
        </p>
      </div>

      <PersonalInformationForm user={user} />

      {multiplePhoneNumbers?.isEnabled && (
        <>
          <div>
            <h2 className="text-base font-semibold leading-7 text-light-primaryText dark:text-dark-primaryText">
              {t('Phone numbers')}
            </h2>
            <p className="mt-1 text-sm leading-6 text-light-primaryText dark:text-dark-primaryText">
              {t('Add, change or remove your own phone numbers.')}
            </p>
          </div>
          <UserPhoneNumbers />
        </>
      )}

      <div>
        <h2 className="text-base font-semibold leading-7 text-light-primaryText dark:text-dark-primaryText">
          {t('Change password')}
        </h2>
        <p className="mt-1 text-sm leading-6 text-light-primaryText dark:text-dark-primaryText">
          {t('Update your password associated with your account.')}
        </p>
      </div>

      <ChangePasswordForm />
    </div>
  );
}

export default AccountSettings;
